import produce from 'immer';
import uuid from 'uuid';

import {
  ADD_NEW_CAMPAIGN,
  DELETE_JOURNEY_CAMPAIGN,
  RESET_JOURNEY_DETAILS,
  SUBMIT_MULTI_CAMPAIGN_FORM,
  UPDATE_FORM_VIEW,
  UPDATE_JOURNEY_CHANNEL,
  UPDATE_JOURNEY_CONTENT,
  UPDATE_JOURNEY_SCHEDULE,
  UPDATE_JOURNEY_SEGMENT,
  UPDATE_MULTI_CAMPAIGN_DETAILS,
  UPDATE_MULTI_CAMPAIGN_RESPONSE,
} from '../actions/journeyDetailsActionTypes';
import { DEFAULT_CAMPAIGN_FORM_DATA } from '../constants/campaignConstants';
import { ChannelType } from '../enums/schedulingConstant';
import { newCampaignForm, validateCampaignFormData } from '../util/journey/journeyUtils';

const intialState = {
  journeyName: '',
  journeyDescription: '',
  campaigns: [
    {
      campaignId: uuid.v4(),
      isValid: false,
      content: {
        name: '',
        id: '',
      },
      segment: {
        segmentId: '',
        segmentName: '',
      },
      platform: {
        channel: ChannelType.EMAIL,
      },
      schedule: {
        endTime: '',
        frequency: '',
        startTime: '',
        timeZone: '',
        fromAddress: '',
      },
    },
  ],
  isFormSubmitted: false,
  readonly: false,
  response: {
    status: '',
    data: null,
  },
};

export default function journeyDetails(state = intialState, action) {
  return produce(state, draftState => {
    switch (action.type) {
      case ADD_NEW_CAMPAIGN: {
        draftState.campaigns = [...state.campaigns, newCampaignForm()];
        break;
      }
      case DELETE_JOURNEY_CAMPAIGN: {
        const index = draftState.campaigns.findIndex(cmp => cmp.campaignId === action.payload);
        if (index > -1) {
          draftState.campaigns.splice(index, 1);
        }
        break;
      }
      case UPDATE_JOURNEY_CHANNEL: {
        const { campaignId, data } = action.payload;
        const index = draftState.campaigns.findIndex(cmp => cmp.campaignId === campaignId);
        if (index > -1) {
          draftState.campaigns[index].platform = data;
          draftState.campaigns[index].isValid = validateCampaignFormData(
            draftState.campaigns[index],
          );
        }
        break;
      }
      case UPDATE_JOURNEY_CONTENT: {
        const { campaignId, data } = action.payload;
        const index = draftState.campaigns.findIndex(cmp => cmp.campaignId === campaignId);
        if (index > -1) {
          draftState.campaigns[index].content = data;
          draftState.campaigns[index].isValid = validateCampaignFormData(
            draftState.campaigns[index],
          );
        }
        break;
      }
      case UPDATE_JOURNEY_SEGMENT: {
        const { campaignId, data } = action.payload;
        const index = draftState.campaigns.findIndex(cmp => cmp.campaignId === campaignId);
        if (index > -1) {
          draftState.campaigns[index].segment = data;
          draftState.campaigns[index].isValid = validateCampaignFormData(
            draftState.campaigns[index],
          );
        }
        break;
      }
      case UPDATE_JOURNEY_SCHEDULE: {
        const { campaignId, data } = action.payload;
        const index = draftState.campaigns.findIndex(cmp => cmp.campaignId === campaignId);
        if (index > -1) {
          draftState.campaigns[index].schedule = data;
          draftState.campaigns[index].isValid = validateCampaignFormData(
            draftState.campaigns[index],
          );
        }
        break;
      }
      case UPDATE_MULTI_CAMPAIGN_DETAILS: {
        const { journeyName, journeyDescription } = action.payload;
        draftState.journeyName = journeyName;
        draftState.journeyDescription = journeyDescription;
        break;
      }
      case SUBMIT_MULTI_CAMPAIGN_FORM: {
        draftState.isFormSubmitted = true;
        break;
      }
      case UPDATE_FORM_VIEW: {
        draftState.readonly = action.payload;
        break;
      }
      case UPDATE_MULTI_CAMPAIGN_RESPONSE: {
        draftState.response = action.payload;
        break;
      }
      case RESET_JOURNEY_DETAILS: {
        draftState.journeyName = '';
        draftState.journeyDescription = '';
        draftState.campaigns = [DEFAULT_CAMPAIGN_FORM_DATA];
        draftState.isFormSubmitted = false;
        draftState.readonly = false;
        draftState.response = {
          status: '',
          data: null,
        };
        break;
      }
      default: {
        break;
      }
    }
  });
}
